import Spinner from '@/components/common/Spinner';
import Button from '@/components/common/Button';
import { useGenerateTasks } from '@/hooks/useTasks';
import type { TaskCreationStatus as TaskCreationStatusType } from '@/types/api';

interface TaskCreationStatusProps {
  status: TaskCreationStatusType;
}

export default function TaskCreationStatus({ status }: TaskCreationStatusProps) {
  const generateTasks = useGenerateTasks();

  if (status === 'max_lifetime_tasks') {
    return (
      <div className="border-t border-neutral-200 px-4 py-3">
        <p className="text-center text-sm text-neutral-500">
        <a href="/app/subscription">You've reached the maximum number of Moves for the free plan. Upgrade your subscription to access more Moves.</a>
        </p>
      </div>
    );
  }

  if (status === 'max_active_tasks') {
    return (
      <div className="border-t border-neutral-200 px-4 py-3">
        <p className="text-center text-sm text-neutral-500">
          You've reached the maximum number of active Moves. Complete or dismiss a Move to generate new ones.
        </p>
      </div>
    );
  }

  if (status === 'max_daily_tasks') {
    return (
      <div className="border-t border-neutral-200 px-4 py-3">
        <p className="text-center text-sm text-neutral-500">
          You've reached your daily Move generation limit. New Moves will be available tomorrow.
        </p>
      </div>
    );
  }

  if (status === 'generation_in_progress') {
    return (
      <div className="border-t border-neutral-200 px-4 py-3">
        <div className="flex items-center justify-center gap-2">
          <Spinner size="sm" />
          <p className="text-sm text-neutral-600">Creating new Moves. This may take several minutes...</p>
        </div>
      </div>
    );
  }

  // can_generate
  return (
    <div className="border-t border-neutral-200 px-4 py-3">
      <div className="flex justify-center">
        <Button
          variant="primary"
          size="sm"
          onClick={() => generateTasks.mutate()}
          loading={generateTasks.isPending}
          disabled={generateTasks.isPending}
        >
          Create new Moves
        </Button>
      </div>
    </div>
  );
}
